import { render, staticRenderFns } from "./CorrespondenceList.vue?vue&type=template&id=36e4ac02&"
import script from "./CorrespondenceList.vue?vue&type=script&lang=js&"
export * from "./CorrespondenceList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports